import React from 'react';
import { EbookTemplate } from '../../_templates/EbookTemplate';

export const Ebook = () => {
  return (
    <EbookTemplate />
  );
};
